import React, { useState, useRef } from 'react';

const Login = ({ API_BASE_URL, onLoginSuccess, onBack }) => {
  const [groupCode, setGroupCode] = useState(localStorage.getItem('groupCode') || '');
  const [userId, setUserId] = useState(localStorage.getItem('userId') || '');
  const [password, setPassword] = useState(localStorage.getItem('password') || '');
  const [rememberMe, setRememberMe] = useState(!!localStorage.getItem('password'));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const groupCodeRef = useRef(null);
  const userIdRef = useRef(null);
  const passwordRef = useRef(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (!groupCode.trim()) {
      setError('그룹코드를 입력해주세요.');
      groupCodeRef.current?.focus();
      return;
    }

    if (!userId.trim()) {
      setError('아이디를 입력해주세요.');
      userIdRef.current?.focus();
      return;
    }

    if (!password.trim()) {
      setError('패스워드를 입력해주세요.');
      passwordRef.current?.focus();
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          groupCode: groupCode.trim(),
          userId: userId.trim(),
          password: password.trim(),
        }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        // 로그인 성공 시 정보 저장
        if (rememberMe) {
          localStorage.setItem('groupCode', groupCode.trim());
          localStorage.setItem('userId', userId.trim());
          localStorage.setItem('password', password.trim()); // 패스워드 저장 (사용자 요청)
          localStorage.setItem('token', result.token || '');
        } else {
          // 세션 스토리지에만 저장 (브라우저 닫으면 삭제)
          sessionStorage.setItem('groupCode', groupCode.trim());
          sessionStorage.setItem('userId', userId.trim());
          sessionStorage.setItem('token', result.token || '');

          // 로컬 스토리지 클리어 (이전 저장 정보 삭제)
          localStorage.removeItem('groupCode');
          localStorage.removeItem('userId');
          localStorage.removeItem('password');
          localStorage.removeItem('token');
        }

        // 부모 컴포넌트에 로그인 성공 알림
        if (onLoginSuccess) {
          onLoginSuccess({
            groupCode: groupCode.trim(),
            userId: userId.trim(),
          });
        }
      } else {
        setError(result.message || '로그인에 실패했습니다.');
      }
    } catch (err) {
      console.error('로그인 오류:', err);
      setError('로그인 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = () => {
    // TODO: Google 로그인 구현
    alert('Google 로그인은 준비 중입니다.');
  };

  const handleNaverLogin = () => {
    // TODO: Naver 로그인 구현
    alert('Naver 로그인은 준비 중입니다.');
  };

  const handleKakaoLogin = () => {
    // TODO: Kakao 로그인 구현
    alert('Kakao 로그인은 준비 중입니다.');
  };

  const handleTonggwanLogin = () => {
    // TODO: 통관 로그인 구현
    alert('통관 로그인은 준비 중입니다.');
  };

  return (
    <div className="h-screen w-screen flex justify-center mx-auto items-center bg-gray-50">
      <div className="min-w-[450px] max-w-[450px] min-h-64 p-8 rounded-lg bg-white shadow-lg">
        <div className="w-full h-full flex flex-col">
          {/* 헤더 */}
          <div className="mb-6">
            <button
              onClick={onBack}
              className="text-gray-500 hover:text-gray-900 flex items-center text-sm font-medium transition-colors"
            >
              ← 메인으로 돌아가기
            </button>
          </div>
          <div className="text-4xl justify-center flex font-bold items-center mb-2" style={{ color: '#1A1B1E' }}>
            다시 만나서 반갑습니다.
          </div>
          <div className="text-xl text-gray-500 justify-center flex items-center mb-6">
            그룹코드, 아이디, 패스워드를 입력해주세요
          </div>

          {/* 에러 메시지 */}
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded text-red-600 text-sm">
              {error}
            </div>
          )}

          {/* 로그인 폼 */}
          <form onSubmit={handleLogin} className="flex flex-col space-y-3 mb-4">
            <div>
              <input
                ref={groupCodeRef}
                type="text"
                value={groupCode}
                onChange={(e) => setGroupCode(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    userIdRef.current?.focus();
                  }
                }}
                placeholder="그룹코드*"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                disabled={loading}
              />
            </div>
            <div>
              <input
                ref={userIdRef}
                type="text"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    passwordRef.current?.focus();
                  }
                }}
                placeholder="아이디*"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                disabled={loading}
              />
            </div>
            <div>
              <input
                ref={passwordRef}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    handleLogin(e);
                  }
                }}
                placeholder="패스워드*"
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                disabled={loading}
              />
            </div>
            <div>
              <button
                type="submit"
                disabled={loading}
                className="w-full px-4 py-3 bg-black text-white rounded-md hover:bg-gray-800 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed font-medium"
              >
                {loading ? '로그인 중...' : '로그인'}
              </button>
            </div>

            {/* 로그인 정보 저장 체크박스 */}
            <div className="flex items-center">
              <input
                id="remember-me"
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
              <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900 cursor-pointer">
                로그인 정보 저장 (자동 로그인)
              </label>
            </div>
          </form>

          {/* 구분선 */}
          <div className="relative mb-4">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-300"></div>
            </div>
            <div className="relative flex justify-center text-xs uppercase">
              <span className="bg-white px-2 text-gray-500">또는</span>
            </div>
          </div>

          {/* SNS 로그인 버튼 */}
          <div className="flex flex-col items-center space-y-2 mb-4">
            <button
              onClick={handleGoogleLogin}
              className="w-full h-12 flex items-center justify-center relative border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
              disabled={loading}
            >
              <div className="w-6 h-6 absolute left-4 flex items-center justify-center bg-white rounded border border-gray-300">
                <span className="text-xs font-bold text-blue-600">G</span>
              </div>
              <span className="text-gray-700">구글 로그인</span>
            </button>
            <button
              onClick={handleNaverLogin}
              className="w-full h-12 flex items-center justify-center relative border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
              disabled={loading}
            >
              <div className="w-7 h-7 absolute left-4 flex items-center justify-center bg-green-500 rounded text-white font-bold text-sm">
                <span>N</span>
              </div>
              <span className="text-gray-700">네이버 로그인</span>
            </button>
            <button
              onClick={handleKakaoLogin}
              className="w-full h-12 flex items-center justify-center relative border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
              disabled={loading}
            >
              <div className="w-8 h-8 absolute left-4 flex items-center justify-center bg-gray-200 rounded text-black text-xs font-bold">
                <span>TALK</span>
              </div>
              <span className="text-gray-700">카카오 로그인</span>
            </button>
            <button
              onClick={handleTonggwanLogin}
              className="w-full h-12 flex items-center justify-center relative border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
              disabled={loading}
            >
              <div className="w-6 h-6 absolute left-4 flex items-center justify-center bg-gray-400 rounded text-black font-bold text-xs">
                <span>L</span>
              </div>
              <span className="text-gray-700">통관 로그인</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
